import { Box, Link, Typography, useTheme } from "@mui/material";

type ItemContributorProps = {
  primaryText?: string;
  secondaryText?: string;
  secondaryUrl?: string;
  icon?: React.ReactNode;
};
export const ItemContributor = ({
  primaryText,
  secondaryText,
  secondaryUrl,
  icon,
}: ItemContributorProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column">
      <Typography
        variant="caption"
        textTransform="uppercase"
        fontWeight={700}
        sx={{ color: theme.palette.secondary[700] }}
      >
        {primaryText}
      </Typography>
      {secondaryUrl ? (
        <Link
          href={
            secondaryUrl?.startsWith("http")
              ? secondaryUrl
              : `https://${secondaryUrl}`
          }
          target="_blank"
          variant="caption"
          sx={{
            display: "flex",
            gap: 0.5,
            alignItems: "center",
            textDecoration: "none",
            color: theme.palette.primary[500],
          }}
        >
          {icon}
          {secondaryText}
        </Link>
      ) : (
        <Typography
          variant="caption"
          sx={{ color: theme.palette.secondary[100] }}
        >
          {secondaryText}
        </Typography>
      )}
    </Box>
  );
};
